var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatarMissing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "736CD4B9-1011-4D97-AA3E-1DBB0CFC0AB2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Appointment-Cards",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "HK-Full---Mobile---Schedule-Cards",
    transform: "translate(-864.000000, -1247.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(848.000000, 1175.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7-Copy",
    transform: "translate(16.000000, 72.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#AEAEAE",
    x: 2.18181818,
    y: 2.18181818,
    width: 45.8181818,
    height: 45.8181818,
    rx: 8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-19",
    fill: "#F0F0F0",
    x: 0,
    y: 0,
    width: 45.8181818,
    height: 45.8181818,
    rx: 8
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(6.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.84692383,34.0947563 L32.045166,34.0947563 C32.5974496,34.0936063 33.0442334,33.6449615 33.0430856,33.092678 C33.0426251,32.8711097 32.9685919,32.6559685 32.8324877,32.4811304 C28.5032849,26.8902143 23.1090389,24.0947563 16.6497497,24.0947563 C10.1766843,24.0947563 4.96986814,26.9021511 1.02930122,32.5169408 C0.712374902,32.9692459 0.819939707,33.5932072 1.2711313,33.9117109 C1.43959808,34.0306344 1.64071077,34.0945683 1.84692383,34.0947563 Z",
    id: "Path-20",
    fill: "#AEAEAE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6666667,24.99474 C11.0381234,28.3947508 13.1418514,30.0947563 16.9778506,30.0947563 C20.8138499,30.0947563 22.9434118,28.4669622 23.3665365,25.2113741 C21.4823831,24.4669622 19.3598516,24.0947563 16.9989421,24.0947563 C14.6380325,24.0947563 12.527274,24.3947508 10.6666667,24.99474 Z",
    id: "Path-23",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3333333,20.0947563 L13.3333333,25.1746367 C13.3333333,26.6769386 14.4444444,27.4280896 16.6666667,27.4280896 C18.8888889,27.4280896 20,26.6769386 20,25.1746367 L20,20.0947563 L13.3333333,20.0947563 Z",
    id: "Path-24",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5646221,16.262029 C11.8529157,20.7064734 12.9229281,22.9286957 16.7746594,22.9286957 C20.6263907,22.9286957 21.6964031,20.7064734 19.9846967,16.262029 L13.5646221,16.262029 Z",
    id: "Path-24-Copy",
    fill: "#AEAEAE"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 16.4863241,
    cy: 11.3333333,
    rx: 8,
    ry: 10.6666667
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.48632411,9.96943074 L10.2000113,7.05270873 C11.277643,5.2185631 13.2458965,4.09215209 15.3731906,4.09215209 L17.4469029,4.09215209 C19.4955396,4.09215209 21.4025832,5.13740635 22.5046878,6.86433356 L24.4863241,9.96943074 L24.4863241,9.96943074 C24.6029724,3.32314358 21.8543567,0 16.240477,0 C10.6265973,0 8.04187967,3.32314358 8.48632411,9.96943074 Z",
    id: "Path-25",
    fill: "#AEAEAE"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarMissing);
export default __webpack_public_path__ + "static/media/avatar-missing.cc3afd8cf7522d855a315eea80b41155.svg";
export { ForwardRef as ReactComponent };